import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { initRuntimeReporter } from "@plerity/runtime-reporter";

// Phase 7: production runtime-error reporter — captures window.error +
// unhandledrejection and POSTs to /api/observability/errors.
// Disabled in dev (the test-time helper handles E2E specs).
initRuntimeReporter({
  app: "booking",
  disabled: import.meta.env.MODE !== "production",
  buildSha: import.meta.env.VITE_BUILD_SHA ?? "dev",
});

/**
 * Enable MSW mock service worker in development when the real
 * booking API isn't running. This provides empty-state data for
 * all pages so the UI is testable without backend auth.
 */
async function enableMocking() {
  if (import.meta.env.DEV && import.meta.env.VITE_ENABLE_MSW !== "false") {
    try {
      const { worker } = await import("./mocks/browser");
      await worker.start({
        onUnhandledFrame: "bypass",
        quiet: true,
      });
    } catch {
      // MSW not available — continue without mocking
    }
  }
}

// Register the X-Tenant-Id request interceptor on the shared dashboard
// apiClient so org-switcher selections scope queries (not just mutations).
// Lives in the API layer (apiClientSetup) — see that file for the rationale.
import { registerBookingApiInterceptors } from "./routes/booking/api/apiClientSetup";

registerBookingApiInterceptors();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");

enableMocking().then(() => {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
